import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ArcButton from './ArcButton';
import { ArcButtonGroupContextProvider } from './context';
import groupStyle from './Group.module.scss';


function Group(props) {
  const {
    options,
    width,
    value,
  } = props;

  const len = options.length;
  const [val, setVal] = useState(value);
  const onButtonChange = (e) => {
    setVal(e);
    const { onChange } = props;
    if (e !== val) {
      onChange(e);
    }
  };

  const renderGroup = () => options.map((item) => (
    <ArcButton
      width={width}
      key={item}
      text={item}
      checked={val === item}
    >
      {item}
    </ArcButton>
  ));

  return (
    <ArcButtonGroupContextProvider value={{ onChange: onButtonChange }}>
      <div className={groupStyle['arc-group-button']} style={{ width: `${width * len + (len - 1) * 20}px` }}>
        {renderGroup()}
      </div>
    </ArcButtonGroupContextProvider>
  );
}

Group.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  width: PropTypes.number,
  value: PropTypes.string,
};

Group.defaultProps = {
  options: [], // 按钮文案数组
  onChange: () => {}, // 点击当前按钮事件
  width: 300, // 设置每个按钮的宽度
  value: '', // 绑定的值
};

export default Group;
